import { http } from "../http";
import { InviteJoinModal } from "@/facilities/model/user";

export const userSuspend = async (ids: number | number[]) => {
  return await http.put("/api/user/suspend", { ids });
};

// 邀请用户加入
export const userInvite = async (params: InviteJoinModal) => {
  return await http.post("/api/user/invite", params);
};

// remove
export const removeUser = async (ids: number | number[]) => {
  return await http.put("/api/user/remove", { ids });
};

// 编辑用户
export const eidtUser = async (params: InviteJoinModal) => {
  return await http.put("/api/user", params);
};

export const userResume = async (ids: number | number[]) => {
  return await http.put("/api/user/resume", { ids });
};

export const userTryJoinNow = async (token: string) => {
  return await http.post(`/api/user/try-join/${token}`);
};

// 应邀加入
export const registerUser = async (params: InviteJoinModal) => {
  return await http.put("/api/register", params);
};

// 重置密码发送邮件
export const putVerificationCode = async (email: string) => {
  return await http.put("/api/anonymity/reset-passwd-verification-code", {
    email,
  });
};

// 重置密码
export const putResetPasswd = async (code: string | null, password: string) => {
  return await http.put("/api/anonymity/reset-passwd", {
    code,
    password,
  });
};

export const passVerifCode = async (code: string | null, type: string) => {
  return await http.put("/api/anonymity/verification-code", {
    code,
    type,
  });
};
